'use client';
import React from 'react';
import Image from 'next/image';
import SectionImage from '@/components/(landing)/landing/SectionImage';

interface HonorsProps {
    data?: { images: { sourceUrl: string; title: string }[] };
}

const Honors = ({ data }: HonorsProps) => {
    return (
        <section className='bg-[#EAEAEA]'>
            <div className='max-w-5xl mx-auto max-lg:px-5 lg:pt-10 pb-20 grid lg:grid-cols-8 grid-cols-5 items-center justify-between gap-2 lg:gap-y-5'>
                {data?.images.map((operator, index) => (
                    <React.Fragment key={`wrapper-${index}`}>
                        {index === 10 && (
                            <SectionImage
                                key='custom-section-10'
                                className='lg:col-span-4 col-span-4 row-span-1 lg:row-span-2'
                                imageUrl='/nokhbegan/9-honors.webp'
                            />
                        )}

                        {/* Always render the original image */}
                        <Image
                            key={`image-${index}`}
                            src={operator?.sourceUrl || ''}
                            className='object-cover md:w-32 lg:w-24 w-16 h-auto rounded-xl'
                            width={1800}
                            height={1800}
                            alt={operator?.title}
                        />
                    </React.Fragment>
                ))}
            </div>
        </section>
    );
};

export default Honors;
